<template></template>

<script>
export default {
  name: "ReportAlertList",
};
</script>

<style scoped></style>
